var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19895_149986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 4.99998V7.49998L13.3333 4.16665L9.99992 0.833313V3.33331C6.31659 3.33331 3.33325 6.31665 3.33325 9.99998C3.33325 11.3083 3.71659 12.525 4.36659 13.55L5.58325 12.3333C5.20825 11.6416 4.99992 10.8416 4.99992 9.99998C4.99992 7.24165 7.24159 4.99998 9.99992 4.99998ZM15.6333 6.44998L14.4166 7.66665C14.7833 8.36665 14.9999 9.15831 14.9999 9.99998C14.9999 12.7583 12.7583 15 9.99992 15V12.5L6.66659 15.8333L9.99992 19.1666V16.6666C13.6833 16.6666 16.6666 13.6833 16.6666 9.99998C16.6666 8.69165 16.2833 7.47498 15.6333 6.44998Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19895_149986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew);
export default __webpack_public_path__ + "static/media/renew.4460982d7e4a2d4c1d888c7e1fe8ad1c.svg";
export { ForwardRef as ReactComponent };